import { BitkitSearchInput } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Separator } from '@chakra-ui/react/separator';
import { Text } from '@chakra-ui/react/text';

import AppList from '../Search/AppList';
import useSearch from '../useSearch';

const HelpDrawer = () => {
  const { query, setQuery, appList, isLoading } = useSearch();
  const isOpen = !!appList && !isLoading;
  return (
    <>
      <Box>
        <BitkitSearchInput
          label="Search projects"
          placeholder="Search projects..."
          value={query}
          onChange={(newValue) => setQuery(newValue)}
          paddingX="16"
        />
      </Box>
      <Separator marginTop="24" marginBottom="12" />
      <Box>
        {!query && (
          <Text color="text/secondary" textStyle="body/lg/regular" paddingX="24" paddingY="8">
            Start typing to get results.
          </Text>
        )}

        {query && appList && <AppList apps={appList} isOpen={isOpen} />}
      </Box>
    </>
  );
};

export default HelpDrawer;
